export const SET_DATA = "setData";
export const CLEAR_DATA = "clearData";
export const SET_LOADING_STATUS = "setLoadingStatus";
